import { n$2, t$2 } from '@/js/global/global'
import { shouldAnimate } from '@/js/global/helpers'
import { register } from '@/js/global/shopify-theme-sections'
import { animateSearchWithinPage } from '@/js/global/animations'
import Mark from 'mark.js'

const searchWithinPageEls = {
  markjsinput: 'input[name="search-within-page-keyword"]',
  sectionsToSearch: '#main .shopify-section:not(:first-child) [data-section-type]:not([data-section-type="search-within-page"])',
  collapsibleRowListItems: '#main .collapsible-row-list-item',
};
register("search-within-page", {
  onLoad() {
    this.events = [];
    if (shouldAnimate(this.container)) {
      this.animateSearchWithinPage = animateSearchWithinPage(this.container);
    }
    const keywordInputEl = n$2(searchWithinPageEls.markjsinput, this.container)
    const sectionsSearchContext = t$2(searchWithinPageEls.sectionsToSearch, document)
    const collapsibleRowListItems = t$2(searchWithinPageEls.collapsibleRowListItems, document)

    if (keywordInputEl) {
      // Declare mark.js context and options
      const context = new Mark( sectionsSearchContext );

      const performMark = (evt) => {

        if ( evt.keyCode == 13 ) {// enter
            keywordInputEl.blur();
            return true;
        }

        // Read the keyword
        let keyword = keywordInputEl.value;

        if ( keyword.trim() == '' ) {
          for (let i = sectionsSearchContext.length - 1; i >= 0; i--) {
            show( sectionsSearchContext[i] )
          }
          for (let i = collapsibleRowListItems.length - 1; i >= 0; i--) {
            show( collapsibleRowListItems[i] )
          }
        }

        // Remove previous marked elements first, then mark the new keyword inside the context
        context.unmark({
          done: function(){

            // Show all Sections on the page
            for (let i = sectionsSearchContext.length - 1; i >= 0; i--) {
              show( sectionsSearchContext[i] )
            }
            // Show all collapsible-row-list items on the page
            for (let i = collapsibleRowListItems.length - 1; i >= 0; i--) {
              show( collapsibleRowListItems[i] )
            }

            context.mark(keyword, {

              done: (results) => {

                for (let i = sectionsSearchContext.length - 1; i >= 0; i--) {
                  let searchedTerms = sectionsSearchContext[i].querySelectorAll('[data-markjs]');

                  if ( searchedTerms.length || results === 0 ) {
                    show( sectionsSearchContext[i] )
                  } else {
                    hide(sectionsSearchContext[i])
                  }
                }
                for (let i = collapsibleRowListItems.length - 1; i >= 0; i--) {
                  let searchedTerms = collapsibleRowListItems[i].querySelectorAll('[data-markjs]');

                  if (searchedTerms.length || results === 0) {
                    // Ensure parent section is shown
                    const parentSectionInnerEl = collapsibleRowListItems[i].closest('.section')
                    show( parentSectionInnerEl )

                    // Also show any immedietly preceding rich text sections
                    const parentSectionEl = collapsibleRowListItems[i].closest('.shopify-section')
                    const precedingSectionEl = parentSectionEl.previousElementSibling
                    if ( precedingSectionEl ) {
                      const precedingRichTextEl = precedingSectionEl.querySelector('.section.rich-text')
                      if ( precedingRichTextEl ) {
                        show( precedingRichTextEl )
                      }
                    }

                    show( collapsibleRowListItems[i] )
                  } else {
                    hide( collapsibleRowListItems[i] )
                  }
                }
              }
            });
          }
        });
      }

      const hide = (el) => {
        el.classList.add('swp-hidden')
        el.setAttribute('aria-hidden', 'true')
      }

      const show = (el) => {
        if ( el.classList.contains('swp-hidden') ) {
          el.classList.remove('swp-hidden')
        }
        el.setAttribute('aria-hidden', 'false')
      }

      // Listen to input and option changes
      keywordInputEl.addEventListener("keyup", performMark);
    }
  },

  onUnload() {
    var _this$observer;
    this.events.forEach(unsubscribe => unsubscribe());
    (_this$observer = this.observer) === null || _this$observer === void 0 ? void 0 : _this$observer.destroy();
  }
});
